import * as XLSX from "xlsx";

export type RowData = Record<string, string | null>;

export const parseDataRows = (endCol: string, worksheet: XLSX.WorkSheet) => {
  const rows: RowData[] = [];

  const range = XLSX.utils.decode_range(worksheet["!ref"] || "A1");

  for (let row = 7; row <= range.e.r; row++) {
    const startCol = "B";
    const result: Record<string, string | null> = {};

    for (let col = XLSX.utils.decode_col(startCol); col <= XLSX.utils.decode_col(endCol); col++) {
      const colLetter = XLSX.utils.encode_col(col);
      const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
      const cell = worksheet[cellRef];
      result[colLetter] = cell?.v ?? null;
    }

    if (result.B != null) {
      rows.push(result);
    }
  }

  return rows;
};
